import styled, { css } from "styled-components";

import { colors } from "../../../constants/colors";

type ButtonTypes =
  | "primary"
  | "primary-outline"
  | "secondary"
  | "danger"
  | "danger-outline";

type ButtonSizes =
  | "xsmall"
  | "small"
  | "medium"
  | "xmedium"
  | "large"
  | "xlarge"
  | "checkbox";

export type StyledButtonProps = {
  buttonType?: ButtonTypes | undefined;
  size?: ButtonSizes | undefined;
};

const createButtonStyleByType = (type?: ButtonTypes) => {
  switch (type) {
    case "primary":
      return css`
        border-radius: 2px;
        background: ${colors.priamry};
        border: 0px;
        color: ${colors.white};
      `;
    case "secondary":
      return css`
        border-radius: 2px;
        background: ${colors.secondary};
        border: 0px;
        color: ${colors.white};
      `;
    case "danger":
      return css`
        border-radius: 2px;
        background: ${colors.danger};
        border: 0px;
        color: ${colors.white};
      `;
    case "danger-outline":
      return css`
        border-radius: 2px;
        border: 1px solid ${colors.danger};
        color: ${colors.danger};
      `;
    default:
      return css`
        border-radius: 2px;
        border: 1px solid ${colors.text};
        color: ${colors.text};
      `;
  }
};

const createButtonStyleBySize = (size?: ButtonSizes) => {
  switch (size) {
    case "xsmall":
      return css`
        font-size: 14px;
        width: auto;
        height: 28px;
        padding: 0 10px;
      `;
    case "small":
      return css`
        font-size: 14px;
        width: 112px;
        height: 28px;
      `;
    case "xmedium":
      return css`
        font-size: 16px;
        width: 170px;
        height: 32px;
      `;
    case "large":
      return css`
        font-size: 20px;
        width: 240px;
        height: 36px;
      `;
    case "xlarge":
      return css`
        font-size: 24px;
        width: 338px;
        height: 56px;
      `;
    case "checkbox":
      return css`
        font-size: 18px;
        width: 24px;
        height: 24px;
      `;
    default:
      return css`
        font-size: 16px;
        width: 128px;
        height: 32px;
      `;
  }
};

export const StyledButton = styled.button<StyledButtonProps>`
  background-color: white;
  ${({ buttonType }) => createButtonStyleByType(buttonType)}
  ${({ size }) => createButtonStyleBySize(size)}
  max-width: 100%;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
  :disabled {
    cursor: default;
    opacity: 0.3;
  }
`;
